<template>
  <div class="form-heading">
    <div class="form-heading__ordinal">{{ ordinal }}</div>
    <h1 class="form-heading__title">{{ title }}</h1>
    <p
      class="form-heading__subtitle"
      v-if="!!subtitle"
    >
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FormHeading',
  props: {
    ordinal: {
      type: [Number, String],
      deault: 0,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .form-heading {
      margin-bottom: 16px;

      @include md-up {
        margin-bottom: 80px;
      }

    &__ordinal {
      color: $red;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
      text-align: center;

      @include md-up {
        margin-bottom: 14px;
      }
    }

    &__title {
      font-size: 16px;
      font-weight: 600;
      text-align: center;

      @include md-up {
        font-size: 18px;
      }
    }

    &__subtitle {
      color: $secondary;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: .19px;
      margin-top: 12px;
      text-align: center;

       @include md-up {
        font-size: 14px;
      }
    }
  }
</style>
